module.exports = __webpack_public_path__ + "static/media/ImporterFeatureIcon8.90f9307d.svg";